import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { paymentTermsStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsPaymentTerms";
import { statusStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsStatus";
import { TYPOGRAPHY } from "@tSurya/theme/design";
import { css } from "styled-components";

paymentTermsStyles.titleText = mergeToNew(paymentTermsStyles.titleText, {
    css: css`
       line-height: ${TYPOGRAPHY.lineHeight.xmedium};
       font-weight: ${TYPOGRAPHY.weight.mediumbold};
       margin-bottom: 5px;
    `,
});



